import { AppShellProvider } from '../appShell';
import {
  SdfMfeLoader
} from '@waypoint/react-components';
const webhookUIBaseUrl = import.meta.env.VITE_API_BASE_URL;
const appShellBaseUrl = import.meta.env.VITE_APP_SHELL_BASE_URL;

function DataWebhook({ mfeKey, carId, locale }) {
  return (
    <>
      <div className="px-8">
        {/* Loading the appShell */}
        <AppShellProvider baseURL={appShellBaseUrl} locale={locale}>
          {/* Loading the OpenADP WebhookUI MFE */}
          <SdfMfeLoader
            key={mfeKey}
            id='data-webhook-mfe'
            // baseUrl={'http://localhost:4901'} // For local MFE testing
            baseUrl={`${webhookUIBaseUrl}/marketplace-webhookui-mfe`}
            scriptName='config/ui-config.js'
            globalObject='webhookmanager'
            componentTagName='ui-host'
            dataAttrCid={carId}
          />
        </AppShellProvider>
      </div>

      {/* Spacing */}
      <br />
      <br />
      <br />
      <br />
    </>
  );
}

export default DataWebhook;
